interface EventProps {
  summary: string
  start: string
  end: string
  address: string
  description: string
}

interface Props {
  events: Array<EventProps>
}

export const createIcsUrl = ({ events }: Props) => {
  const vevents = events.map((event) => {
    const formattedDescription = event.description.replace(/\n/g, '\\n').replace(/,/g, '\\,')
    const formattedAddress = event.address.replace(/,/g, '\\,').replace(/\s\s/g, ' ')

    const eventLines = [
      'BEGIN:VEVENT',
      `DTSTART:${formatDateForICS(event.start)}`,
      `DTEND:${formatDateForICS(event.end)}`,
      `SUMMARY:${event.summary}`,
      `LOCATION:${formattedAddress}`,
      `DESCRIPTION:${formattedDescription}`,
    ]

    eventLines.push('BEGIN:VALARM', 'TRIGGER:-PT12H', 'REPEAT:1', 'ACTION:DISPLAY', 'END:VALARM', 'END:VEVENT')

    return eventLines.join('\n')
  })

  return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Eversports//Booking//EN', ...vevents, 'END:VCALENDAR'].join('\n')
}

const formatDateForICS = (date: string) => {
  // as ISOString
  let isoDateString = new Date(date).toISOString()
  // remove milliseconds
  isoDateString = isoDateString.split('.')[0] + 'Z'
  // remove dashes and colons
  isoDateString = isoDateString.replace(/-/g, '')
  isoDateString = isoDateString.replace(/:/g, '')

  // now formatted as YYYYMMDDTHHMMSSZ
  return isoDateString
}
